import React, { useRef } from "react";

export const DataRows = (props) => {
  const { currentData, renderRows, errorFlag, displaySearchFilter } = props;
  const tableBodyNode = useRef();
  return (
    <>
      <tbody className="table-root__body" ref={tableBodyNode}>
        {currentData.length > 0 ? (
          renderRows()
        ) : (
          <tr>
            {displaySearchFilter ? (
              <td colSpan={12}>
                <div className="d-flex flex-column text-center">
                  <div className={"no-results--text" + (errorFlag ? " hasEror" : "")}>
                    {errorFlag ? "An error occurred during your search. Please try again later." : "No results found"}
                  </div>
                  <div className="no-results--info">
                    Try adjusting your search or filter to what you are looking for
                  </div>
                </div>
              </td>
            ) : (
              <td colSpan={12} className={"no-results--text text-center" + (errorFlag ? " hasEror" : "")}>
                {errorFlag
                  ? "An error occurred during your search. Please try again later."
                  : "Zero results were found based on your search criteria."}
              </td>
            )}
          </tr>
        )}
      </tbody>
    </>
  );
};
